module.exports = __webpack_public_path__ + "img/sb.825a25c6.png";